import { createFileRoute, redirect } from "@tanstack/react-router";

/** Oude datum-URL's (/nieuws/JJJJ/MM/slug/) blijven werken via een redirect. */
export const Route = createFileRoute("/nieuws/$year/$month/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/nieuws/$slug/", params: { slug: params.slug } });
  },
  component: () => null,
});
